<template>
<div class="main-content-container container-fluid h-100 px-4">
    <div class="row h-100 no-gutters">
        <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">

            <div class="card">
                <d-card-header class="border-bottom">

                    <strong class="s2 app_fontsize">Forgot Password</strong>

                </d-card-header>
                <div class="card-body">
                    <!---->
                    <!---->
                    <!-- <img
              src="/demo/shards-dashboard-vue/img/shards-dashboards-logo.60a85991.svg"
              alt="Dev Tools - Login Template"
              class="auth-form__logo d-table mx-auto mb-3"
            /> -->

                    <form class>
                        <div class="form-group">
                            <label for="exampleInputEmail1">EmailId</label>
                            <input id="exampleInputEmail1" type="email" placeholder="Email ID" class="form-control" />
                        </div>
                        <div class="form-group">
                            <label for="exampleInputPassword1">Mobile</label>
                            <d-datepicker placeholder="Mobile" typeable small />
                        </div>

                        <div class="row">
                            <button type="submit" class="btn btn-pill btn-accent d-table mx-auto">Submit</button>
                            <button type="submit" class="btn btn-pill btn-accent d-table mx-auto">Reset</button>
                        </div>
                    </form>
                </div>
                <div class="border-top card-footer">

                    <div class="row">
                        <a style="color: rgb(0, 123, 255);cursor:pointer; " @click="ForgotPasswordClick()" class target="_self">Redirect to Login</a>
                    </div>
                </div>
            </div>
            <div class="auth-form__meta d-flex mt-4">
                <!-- <a style="color: rgb(0, 123, 255)" @click="ForgotPasswordClick()" class target="_self">Redirect to Login</a> -->
                <!-- <a
            href="/demo/shards-dashboard-vue/register"
            class="ml-auto"
            target="_self"
          >Create a new account?</a> -->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Utilities from '@/Utilities/Utilities';
export default {
    name: 'ForgotPassword',
    data() {
        return {
            ForgotPassword: {
                PageType: 'Master', // Master, Transaction, Dashboard, Tabb edDashboard
                PageLoad: true, // block/none
                DataModel: {
                    Data: {},
                    UIData: {},
                },
                PageState: 'Default', // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
                TabInfo: {
                    SelectedTabIndex: 0,
                    NumberOfTabs: 0,
                },
                SessionInfo: {
                    SessionTimeout: false,
                    AuthToken: '',
                    SessionID: '',
                    PageInfo: {
                        ClientId: 0,
                        userId: 0,
                        WareHouseId: 0,
                    },
                },
                GridInfo: {},
                Events: {
                    EventRaised: 'Submitted', // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
                    PageToNavigateWhenSubmitted: '', // We can go back to dashboard or stay on the Same page or to a specific page
                },
                ValidationInfo: {},
                ErrorInfo: [{
                    ErrorID: 1,
                    ErrorName: '',
                    ErrorMessage: '',
                }],
                Masters: {},
                Modal: {},
                CharRestrict: {},
            },
        };
    },
    mounted() {},
    methods: {
        ForgotPasswordClick() {
            Utilities.gotoRoute(this, "/");
        },
    },
};
</script>
